<template>
    <div>
        <el-dialog :title="$t('posts.edit.changeMassContactsTitle')"
                :visible="modalConfirmedChangeContactList"
                width="30%"
                v-loading="loading"
                @close="closeChangeContact">
            <div v-if="selection.length <= maxSelection">
                <el-select v-if="getContacts && getContacts.length > 0"  clearable
                           filterable
                           allow-create
                           v-model="contactSelected"
                           @change="changeValue('contact')"
                >
                    <el-option
                        v-for="contact in getContacts"
                        style="text-transform:capitalize"
                        :key="contact.id"
                        :value="contact.id"
                        :label="contact.fullname"
                    ></el-option>
                </el-select>
                <span class="text-left" v-else><br><br>Vous n'avez pas de contacts sur votre compte</span>
                <span class="text-left"><br></span>
                <span class="text-left" v-if="objectContact.contact_a_afficher"><br>{{objectContact.contact_a_afficher}}</span>
                <span class="text-left" v-if="objectContact.email_a_afficher"><br>{{objectContact.email_a_afficher}}</span>
                <span class="text-left" v-if="objectContact.telephone_a_afficher"><br>{{objectContact.telephone_a_afficher}}</span>
                <span class="text-left" v-if="objectContact.telephone_mobile_a_afficher"><br>{{objectContact.telephone_mobile_a_afficher}}</span>
            </div>
            <div v-else>
                {{$t('posts.dialog.lengthSelectedExceeded', {length: maxSelection})}}
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelChangeContact">Annuler</el-button>
                <el-button :disabled="this.disabled" type="danger" @click="changeContact"> {{ $t("general.selection.validate") }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import ElButton from '../../../../components/Button'
import { updateMultiplePosts } from '../../../../services/posts'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'DialogChangeContactMultiplePosts',
  components: {
    ElButton
  },
  props: ['selected'],
  data () {
    return {
      objectContact: {},
      contactSelected: null,
      disabled: true,
      loading: false,
      maxSelection: 30
    }
  },
  computed: {
    ...mapGetters('postsVo', ['getListContacts']),
    ...mapState('postsVo', ['modalConfirmedChangeContactList', 'selection']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    getContacts () {
      return this.getListContacts
    }
  },
  methods: {
    ...mapMutations('postsVo', ['setSelection']),
    closeChangeContact () {
      this.$store.commit('postsVo/setModalConfirmedChangeContactList', false)
    },
    cancelChangeContact () {
      this.$store.commit('postsVo/setModalConfirmedChangeContactList', false)
    },
    changeValue () {
      if (this.contactSelected) {
        const contact = this.getContacts.find(x => x.id === this.contactSelected)
        if (contact) {
          this.objectContact.contact_a_afficher = contact ? contact.fullname : ''
          this.objectContact.email_a_afficher = contact ? contact.email : ''
          this.objectContact.telephone_a_afficher = contact ? contact.phone : ''
          this.objectContact.telephone_mobile_a_afficher = contact ? contact.mobile : ''
          this.disabled = false
        } else {
          this.disabled = true
        }
      }
    },
    typeOfSaisie () {
      let saisie = 'SAISIE_IMMO'
      if (this.sitimmoUser.univers == 'VO') {
        saisie = 'SAISIE_VO'
      }
      return saisie
    },
    async changeContact () {
      let selectionAnnonces = this.selection
      if (selectionAnnonces.length === 0) {
        selectionAnnonces = this.sitimmoUser.selectionItem
      }
      if ((selectionAnnonces.length > 0) && (Object.keys(this.objectContact).length > 0) && (this.sitimmoUser.saisit_annonces_en_ligne === true)) {
        this.loading = true
        await updateMultiplePosts(selectionAnnonces, null, this.typeOfSaisie(), this.objectContact)
        this.$message({ message: this.$t('Vos annonces ont bien été mises à jour'), type: 'success' })
        this.$emit('unselect-call')
      } else {
        this.$message({ message: this.$t('error.found'), type: 'error' })
      }
      this.$emit('unselect-call')
      this.loading = false
      this.contactSelected = null
      this.objectContact = {}
      this.$store.commit('postsVo/setModalConfirmedChangeContactList', false)
      selectionAnnonces = []
      this.setSelection([])
    }
  },
  beforeMount () {
  },
  mounted () {
    this.$store.dispatch('postsVo/loadContacts')
  }
}
</script>
